import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import OpinionDialog from './OpinionDialog'

//Mui content
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DeleteOpinion from './DeleteOpinion'
import MyButton from '../../util/MyButton'
import HateButton from './HateButton'
import IgnoreButton from './IgnoreButton'

const styles = {
    card: {
      position: 'relative',
      display: 'flex',
      marginBottom: 20
    },
    image: {
      width: 128,
      height: 200,
      minWidth: 128
    },
    img: {
      margin: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
    },
    content: {
      padding: 25,
      objectFit: 'cover'
    },
    wreckDisp: {
      display: "-webkit-box",
      boxOrient: "vertical",
      lineClamp: 2,
      wordBreak: "break-all",
      overflow: "hidden"
    }
  };

class Opinion extends Component {
  
    render() {
        dayjs.extend(relativeTime);
        const { classes, wreck: { body, createdAt, userImage, userHandle, wreckID, likeCount, commentCount, ignoreCount }, user: {authenticated, credentials: {handle}} } = this.props;

        const deleteButton = authenticated && userHandle === handle ? (
          <DeleteOpinion wreckID={wreckID} />
        ) : null

        return (
            <Card className={classes.card}>
                <CardMedia component="img" image={userImage} title="Profile Image" className={classes.image} />
                <CardContent className={classes.content}>
                    <Typography variant="h5" component={Link} to={'/users/'+userHandle} color="primary">{userHandle}</Typography>
                    {deleteButton}
                    <Typography variant="body2" color="textSecondary">{dayjs(createdAt).fromNow()}</Typography>
                    <Box
                      component="div"
                      classes={{root: classes.wreckDisp}}
                    >
                     {body}
                    </Box>
                    <IgnoreButton wreckID={wreckID} />
                    <span>{ignoreCount} ignores</span>
                    <HateButton wreckID={wreckID} />
                    <span>{likeCount} hates</span>
                    <MyButton tip='Wrecks'>
                      <FontAwesomeIcon icon="head-side-cough" color='#74022c' />
                    </MyButton>
                    <span>{commentCount} wrecks</span>
                    <OpinionDialog wreckID={wreckID} userHandle={userHandle} openDialog={this.props.openDialog} />
                </CardContent>
            </Card>
        )
    }
}

Opinion.propTypes = {
  user: PropTypes.object.isRequired,
  wreck: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool
}

const mapStateToProps = state => ({
  user: state.user
})



export default connect(mapStateToProps)(withStyles(styles)(Opinion));
